import axios from 'axios'
import Vue from 'vue'
import {
  MODULE_TYPE_SZAFA,
  GLOBAL_MODULE_TYPE_SZAFY,
  GLOBAL_MODULE_TYPE_GARDEROBY,
  globalType
} from '../../resource/ModuleTypes'

// state
export const state = {
  questions: [],
  questionsCarousel: [],
  answerIdQuestion: [],
  sizeModule: [],
  sizeModuleCorrect: {},
  sizeTop: 250,
  countNeedLoad: 0,
  countLoad: 0
}

// getters
export const getters = {
  questions: state => {
    return state.questions
  },

  getQuestionByType: state => (type) => {
    return state.questions.filter(question => question.type_module === type)
  },

  getQuestionById: state => (id) => {
    return state.questions.filter(question => question.id === id)
  },

  questionsCarousel: state => {
    return state.questionsCarousel
  },
  sizeModule: state => {
    return state.sizeModule
  },

  answerIdQuestion: state => {
    return state.answerIdQuestion
  }
}

// mutations
export const mutations = {
  /**
   * @param state
   * @param questions
   */
  fetchQuestions (state, { questions }) {
    state.questions = questions
  },

  /**
   * @param state
   * @param question
   */
  setQuestion (state, question) {
    state.questions.push(question)
  },

  /**
   * Set size module
   *
   * @param state
   * @param size
   * @constructor
   */
  SET_SIZE_MODULE (state, size) {
    state.sizeModule = size
  },

  /**
   * @param state
   * @param question
   */
  updateQuestion (state, question) {
    var foundIndex = state.questions.findIndex(x => x.id === parseInt(question.id))

    Vue.set(state.questions, foundIndex, question)
  },

  /**
   * @param state
   * @param id
   */
  deleteQuestion (state, id) {
    var foundIndex = state.questions.findIndex(x => x.id === parseInt(id))

    state.questions.splice(foundIndex, 1)
  },

  /**
   * @param state
   * @param payload
   */
  setQuestionCarousel (state, payload) {
    var foundIndex = -1

    if (payload.question.type !== 'checkbox') {
      foundIndex = state.questionsCarousel.findIndex(x => x.question.id === parseInt(payload.question.id))
    } else {
      foundIndex = state.questionsCarousel.findIndex(x => x.answer_id === parseInt(payload.answer_id))
    }

    deleteAnswerQuestion(foundIndex, payload)
  },

  /**
   * @param state
   * @param payload
   */
  setQuestionSlideCarousel (state, payload) {
    let foundIndex = state.questionsCarousel.findIndex(x => x.question.id === parseInt(payload.question.id))

    if (foundIndex > -1) state.questionsCarousel.splice(foundIndex, 1) // check if have delete

    state.questionsCarousel.push(payload)
  },

  SET_CORRECT_MODULE (state, payload) {
    state.sizeModuleCorrect = {}

    if (payload.left) {
      state.sizeModuleCorrect.left = payload.left
    }

    if (payload.right) {
      state.sizeModuleCorrect.right = payload.right
    }

    if (payload.middle) {
      state.sizeModuleCorrect.middle = payload.middle
    }

    return state.sizeModuleCorrect
  },

  SET_SIZE_TOP (state, payload) {
    state.sizeTop = payload
  },

  /**
   * @param state
   */
  clearQuestion (state) {
    state.answerIdQuestion = []
    state.questionsCarousel = []
    state.sizeModule = []
  }
}

// actions
export const actions = {
  /**
   * Fetch all type questions
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllQuestions ({ commit }) {
    try {
      var szafy = []

      var garderoby = []

      await indexQuestions(GLOBAL_MODULE_TYPE_SZAFY).then(request => {
        szafy = request
      })

      await indexQuestions(GLOBAL_MODULE_TYPE_GARDEROBY).then(request => {
        garderoby = request
      })

      let data = szafy.concat(garderoby)

      commit('fetchQuestions', { questions: data })
    } catch (e) {
    }
  },

  /**
   * Fetch type questions
   *
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  async fetchTypeQuestions ({ commit }, payload) {
    try {
      axios.get('/api/question', {
        params: {
          type_module: globalType(payload)
        }
      }).then(({ data }) => {
        commit('fetchQuestions', { questions: data })
      })
    } catch (e) {
    }
  },

  /**
   * @param commit
   * @param question
   * @returns {Promise<void>}
   */
  async setQuestion ({ commit }, question) {
    try {
      commit('setQuestion', question)
    } catch (e) {
    }
  },

  /**
   * @param commit
   * @param question
   * @returns {Promise<void>}
   */
  async updateQuestion ({ commit }, question) {
    try {
      commit('updateQuestion', question)
    } catch (e) {
    }
  },

  /**
   * @param commit
   * @param id
   * @returns {Promise<void>}
   */
  async deleteQuestion ({ commit }, id) {
    try {
      commit('deleteQuestion', id)
    } catch (e) {
    }
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  async setQuestionCarousel ({ commit }, payload) {
    try {
      commit('setQuestionCarousel', payload)
    } catch (e) {
    }
  },

  /**
   * @param commit
   * @param dispatch
   * @param rootState
   * @param payload
   * @returns {Promise<void>}
   */
  async setQuestionSlideCarousel ({ commit, dispatch, rootState }, payload) {
    try {
      commit('setQuestionSlideCarousel', payload)

      if (rootState.moduleCurrent.moduleType === MODULE_TYPE_SZAFA) {
        dispatch('sendModuleSizeSzafa', payload)
      } else {
        dispatch('sendModuleSizeGarderob', payload)
      }
    } catch (e) {
    }
  },

  /**
   * Send module size szafa
   *
   * @param commit
   * @param payload
   */
  sendModuleSizeSzafa ({ commit, dispatch }, payload) {
    state.sizeModule = []

    axios.post('/api/module/size', { width: payload.value, type: 'szafy' }).then(request => {
      state.sizeModule.push(request.data)
    })

    dispatch('clearDoorAndModule')
  },

  /**
   * Send module size garderob
   *
   * @param commit
   * @param dispatch
   * @param payload
   */
  sendModuleSizeGarderob ({ commit, dispatch }, payload) {
    state.sizeModule = []

    dispatch('setModuleSize', {
      side: 'left',
      value: payload.value
    })

    dispatch('setModuleSize', {
      side: 'middle',
      value: payload.value
    })

    dispatch('setModuleSize', {
      side: 'right',
      value: payload.value
    })

    dispatch('clearDoorAndModule')
  },

  clearDoorAndModule ({ commit }) {
    commit('doorCurrent/CLEAR_DOOR_CURRENT', '', { root: true })
    commit('doorGarderobyCurrent/CLEAR_DOOR_CURRENT', '', { root: true })

    commit('modules/clearModuleCollection', '', { root: true })
  },

  /**
   * Set module size
   *
   * @param commit
   * @param state
   * @param payload
   */
  setModuleSize ({ commit, state }, payload) {
    if (payload.value[payload.side]) {
      axios.post('/api/module/size', { width: payload.value[payload.side], type: 'garderoby' }).then(({ data }) => {
        data.forEach((item, index) => {
          if (state.sizeModule[index]) {
            state.sizeModule[index][payload.side] = item
          } else {
            state.sizeModule.push({ [payload.side]: item })
          }
        })
      })
    }
  }
}

/**
 * Splice answer
 *
 * @param foundIndex
 * @param payload
 */
function deleteAnswerQuestion (foundIndex, payload) {
  if (foundIndex > -1) {
    state.questionsCarousel.splice(foundIndex, 1)

    state.answerIdQuestion.splice(--foundIndex, 1)

    if (payload.question.type !== 'checkbox') {
      addAndSendSetAnswerQuestion(payload)
    }
  } else {
    addAndSendSetAnswerQuestion(payload)
  }
}

/**
 * Push answer
 *
 * @param payload
 */
function addAndSendSetAnswerQuestion (payload) {
  state.questionsCarousel.push(payload)

  setAnswerQuestion(payload)
}

/**
 * Push answer id to send server
 *
 * @param payload
 */
function setAnswerQuestion (payload) {
  let ob = {}

  ob.id = payload.answer_id

  state.answerIdQuestion.push(ob)
}

/**
 * Index question help function by fetch all
 *
 * @param type
 * @returns {Promise<void>}
 */
async function indexQuestions (type) {
  const { data } = await axios.get('/api/question', {
    params: {
      type_module: type
    }
  })

  return data
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/questions.js